import z from 'zod'

export const ApiErrorCodeZ = z.enum([
	// General
	'authentication_error',
	'error',
	'bad_request',
	'cancelled',
	'conflict',
	'invalid',
	'locked',
	'method_not_allowed',
	'not_found',
	'permission_denied',
	'timeout',
	// Business logic
	'booking_error',
	'car_booking_error',
	'car_get_location_details_error',
	'credit_card_expired',
	'fare_unavailable',
	'result_expired',
	'send_sabre_command_error',
])

export type ApiErrorCode = z.infer<typeof ApiErrorCodeZ>

export const ModalErrorZ = z.strictObject({
	title: z.string(),
	message: z.string(),
})
export type ModalError = z.infer<typeof ModalErrorZ>

export const DetailedApiErrorZ = z.strictObject({
	/**
	 * The type of the error
	 * @example data_expired
	 */
	code: ApiErrorCodeZ,
	/**
	 * The human-readable description of the error code
	 * @example The data (cache) you are trying to get is expired and no longer available
	 */
	message: z.string().optional(),
	/**
	 * The ID of the subsystem where the error have happened
	 * @example pricing
	 */
	reason: z.string().optional(),
	/**
	 * A key-value record with additional data about the error
	 * @example { companyId: 1234 }
	 */
	extra: z.record(z.string(), z.unknown()).optional(),

	/**
	 * When defined, a modal will be displayed
	 */
	modal: ModalErrorZ.optional(),
})
export type DetailedApiError = z.infer<typeof DetailedApiErrorZ>

export const ApiErrorZ = z.union([z.string(), DetailedApiErrorZ])

export type ApiError = z.infer<typeof ApiErrorZ>

export function isModalError(error: ApiError): error is DetailedApiError {
	return Boolean(typeof error !== 'string' && error.modal)
}
